import { NPSSurveyStep } from "@/features/nps/components/NPSSurveyStep";

/**
 * NPS アンケート画面 (/nps/:npsToken)。npsToken は NPSTokenLayout が interceptor へ渡すため、
 * 本画面はパラメータを受け取らず GetNPSContext / SubmitNPSAnswer の表示と送信だけを担う。
 */
export default function NPSPage() {
  return <NPSSurveyStep />;
}
